import {Directive, HostListener, OnDestroy, OnInit} from '@angular/core';
import {TimePickerComponent} from "@progress/kendo-angular-dateinputs";
import {DateInputFormatPlaceholder} from "@progress/kendo-angular-dateinputs/dist/es2015/dateinput/models/format-placeholder.model";
import {LocalizationService} from "@progress/kendo-angular-l10n";

@Directive({
    selector: '[time-picker-defaults]'
})
export class TimePickerDefaultsDirective implements OnInit, OnDestroy {
    constructor(private ls: LocalizationService,
                private component: TimePickerComponent) {
    }

    public ngOnInit(): void {
        this.component.input.inputElement.type = 'tel';
        this.component.format = 'H:mm';
        this.component.placeholder = '';
        this.component.formatPlaceholder = {hour: '0', minute: '00', second: '00'} as DateInputFormatPlaceholder;

        this.component.onFocus.subscribe(() => {
            this.component.input.inputElement.setSelectionRange(0, 9999);
        });
    }

    public ngOnDestroy(): void {
        this.component.onFocus.unsubscribe();
    }

    @HostListener('keydown', ['$event'])
    keyEvent(event: KeyboardEvent) {
        if (event.key === 'Delete' || event.key === 'Backspace') {
            this.component.writeValue(null);
            this.component.input.inputElement.value = '';
            this.component.input.inputElement.setSelectionRange(0, 9999);
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/fw/directives/time-picker-defaults.directive.ts